export default __webpack_public_path__ + "static/bg-3b7221495ac96b657204a5498f6675f8.jpg";